import { Controller } from "@hotwired/stimulus";

// The CRM launch countdown (shared/_crm_launch_countdown, Crm::Seats::LaunchCountdown)
// on the homepage and the agent dashboard. The server renders the phase and
// clock as of the request; this ticks the clock once a second on the browser's
// clock and moves through the phases by itself:
//
//   before launchAt         → "pre_launch", counting down to launchAt
//   launchAt ≤ now < endsAt → "offer", counting down to endsAt
//   endsAt ≤ now            → the countdown hides and stops
//
// Display only: whether a seat gets the launch price is decided on the server
// clock at checkout, never by this clock.
const SECOND = 1000;
const MINUTE = 60 * SECOND;
const HOUR = 60 * MINUTE;
const DAY = 24 * HOUR;

export default class extends Controller {
  static targets = ["phase", "days", "hours", "minutes", "seconds"];
  static values = { launchAt: String, endsAt: String };

  connect() {
    this.launchAt = Date.parse(this.launchAtValue);
    this.endsAt = Date.parse(this.endsAtValue);
    if (Number.isNaN(this.launchAt) || Number.isNaN(this.endsAt)) return;

    this.tick();
    if (!this.element.hidden) this.timer = setInterval(() => this.tick(), SECOND);
  }

  disconnect() {
    this.stop();
  }

  tick() {
    const now = Date.now();
    if (now >= this.endsAt) {
      this.element.hidden = true;
      this.stop();
      return;
    }

    const phase = now < this.launchAt ? "pre_launch" : "offer";
    const target = phase === "pre_launch" ? this.launchAt : this.endsAt;
    this.showPhase(phase);
    this.render(target - now);
  }

  showPhase(phase) {
    this.phaseTargets.forEach((element) => {
      element.hidden = element.dataset.phase !== phase;
    });
  }

  render(remaining) {
    const parts = {
      days: Math.floor(remaining / DAY),
      hours: Math.floor((remaining % DAY) / HOUR),
      minutes: Math.floor((remaining % HOUR) / MINUTE),
      seconds: Math.floor((remaining % MINUTE) / SECOND),
    };
    Object.entries(parts).forEach(([unit, value]) => {
      const element = this.targets.find(unit);
      if (element) element.textContent = String(value).padStart(2, "0");
    });
  }

  stop() {
    if (this.timer) clearInterval(this.timer);
    this.timer = null;
  }
}
